import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const CitiesAreasListContainer = React.lazy(
  () => import('../../containers/cities-areas-list/cities-areas-list.container')
);

export const CitiesAreasRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: (
      <Navigate
        to={(APP_ROUTES.CITIES_AREAS_MODULE.CHILDREN as RouteConfig).CITIES_AREAS_LIST.FULL_PATH}
      />
    )
  },
  {
    path: (APP_ROUTES.CITIES_AREAS_MODULE.CHILDREN as RouteConfig).CITIES_AREAS_LIST.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN, UserRole.E_COMMERCE_MANAGER]}
          component={CitiesAreasListContainer}
        />
      </React.Suspense>
    )
  }
];
